import type { AdminPageAccessRule } from '../../registry.ts';

/** Хто бачить сторінку `holds`: у перший екран їде лише це. */
export default {
  group: 'data',
  permission: 'privacy.manage',
} satisfies AdminPageAccessRule;
